import { render, staticRenderFns } from "./MidwifeSubstitutionOverview.vue?vue&type=template&id=025b678b"
import script from "./MidwifeSubstitutionOverview.vue?vue&type=script&lang=js"
export * from "./MidwifeSubstitutionOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports